// extracted by mini-css-extract-plugin
export default {"pagination":"wP-z","pageSize":"xP-z","disabled":"yP-z","pageGroups":"zP-z","pageGroup":"AP-z","currentPage":"BP-z","previousPage":"CP-z","nextPage":"DP-z"};